import { render, staticRenderFns } from "./b-list.vue?vue&type=template&id=fdafee86&scoped=true&"
import script from "./b-list.vue?vue&type=script&lang=js&"
export * from "./b-list.vue?vue&type=script&lang=js&"
import style0 from "./b-list.vue?vue&type=style&index=0&id=fdafee86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdafee86",
  null
  
)

export default component.exports